import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
// import AccessoryA from './components/AccessoryA';
import BannerA from './components/BannerA';
import BannerB from './components/BannerB';
import BarPromoA from './components/BarPromoA';
import CompareA from './components/CompareA';
import FooterTcA from './components/FooterTcA';
import PageNavLeft, { Theme } from './components/PageNavLeft';
import SectionA from './components/SectionA';
import SectionB from './components/SectionB';
import SectionC1 from './components/SectionC1';
import SectionC2 from './components/SectionC2';
import SectionD from './components/SectionD';
import SectionE from './components/SectionE';
import SectionF from './components/SectionF';
import SectionG from './components/SectionG';
import SectionH from './components/SectionH';
import SectionI from './components/SectionI';
import SectionJ from './components/SectionJ';
import SectionK from './components/SectionK';
import SectionL from './components/SectionL';
import SectionM from './components/SectionM';
import SectionN from './components/SectionN';
import WhatInBoxA from './components/WhatInBoxA';
import { useLang } from '@/i18n';

export default function NA_Product() {
    const { t } = useLang('theProduct.KSP');
    const { pageStatus } = useProductStore();
    const IS_Status_A = pageStatus === IPageStatus.statusA;
    const IS_Status_B = pageStatus === IPageStatus.statusB;

    return (
        <div className="glacier-classic">
            {IS_Status_A && (
                <>
                    <BarPromoA />
                    <BannerA />
                </>
            )}
            {IS_Status_B && <BannerB />}
            <div className="range1">
                <SectionA />
                {IS_Status_A && <SectionB />}
            </div>
            <SectionC1 />
            <div className="range2">
                <SectionD />
            </div>
            <div className="range3">
                <SectionE />
            </div>
            <SectionC2 />
            <SectionF />
            <div className="range4">
                <SectionG />
            </div>
            <SectionH />
            <div className="range5">
                <SectionI />
            </div>
            <div className="range6">
                <SectionJ />
            </div>
            <SectionK />
            <SectionL />
            <SectionM />
            <SectionN />
            <CompareA />
            <WhatInBoxA />
            {/* <AccessoryA /> */}
            <FooterTcA />

            {/* 左侧 nav */}
            <PageNavLeft
                triggerElement=".glacier-classic"
                steps={[
                    { text: t('item1'), href: '#SectionA' },
                    { text: t('item2'), href: '#SectionD' },
                    { text: t('item3'), href: '#SectionE' },
                    { text: t('item4'), href: '#SectionG' },
                    { text: t('item5'), href: '#SectionI' },
                    { text: t('item6'), href: '#SectionJ' },
                ]}
                triggerElements={[
                    { selectors: '#SectionA', theme: Theme.black },
                    { selectors: '#SectionB', theme: Theme.black },
                    { selectors: '#sectionC1', theme: Theme.white },
                    { selectors: '#SectionD', theme: Theme.black },
                    { selectors: '#SectionE', theme: Theme.black },
                    { selectors: '#sectionC2', theme: Theme.white },
                    { selectors: '#SectionF', theme: Theme.black },
                    { selectors: '#SectionI', theme: Theme.black },
                    { selectors: '#SectionJ', theme: Theme.white },
                    { selectors: '#SectionL', theme: Theme.white },
                    { selectors: '#sectionM', theme: Theme.black },
                ]}
            />
        </div>
    );
}
